import { Redirect, Route } from 'react-router-dom';
import { getActiveBearerToken } from '../utils/apiCaller';
export const Protected = ({ component: Component, ...rest }) => {
  // Accept either a normal tenant token OR an active impersonation token —
  // the latter is how the Mika Ops handoff enters the tenant app.
  var session_token = getActiveBearerToken();
  return (
    <Route {...rest} render={props => (
     session_token ? (
      <Component  {...props} />
      ) : (
            <Redirect to={{
              pathname: '/login',
              state: { from: props.location }
            }}
            />
          )
      )} 
    />
  )
};